import { styled, TextField, TextFieldProps } from "@mui/material";

const StyledTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  "& .MuiInputLabel-root.Mui-focused": {
    color:
      theme.palette.mode === "dark"
        ? theme.palette.grey[100] + "!important"
        : theme.palette.primary.main + "!important",
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.grey[100],
  },
}));

export function TextFieldStyled(props: TextFieldProps) {
  return <StyledTextField {...props} />;
}
